export default __webpack_public_path__ + "static/media/Telluride-Jazz-123.c04c4831.jpg";